import React from 'react';
import { useShowContext } from 'framework/show';
import useArtifactService from '../artifactService';
import useArtifactDownloadHelper from '../artifactDownloadHelper';
import useArtifactPreviewHelper from '../artifactPreviewHelper';
import { getLabel, useAsyncValue } from 'framework/utils';
import { useUiTheme } from 'framework/uiTheme';
import { InputLoader } from 'framework/ui/mui-builder';

interface AttachmentsListFieldProps {
  source?: string;
  value?: string[];
  label?: string;
  isDownloadAvailable?: boolean;
  isOneArtifact?: boolean;
  width?: number;
  isVisible?: boolean | ((data: any) => boolean);
  isCandidateService?: boolean;
  isProjectService?: boolean;
  isRiskService?: boolean;
  isStaffingService?: boolean;
  budgetId?: StringOrNumber;
}

const AttachmentsListField: React.FC<AttachmentsListFieldProps> = ({
  source = '',
  value: inputValue = null,
  label: propsLabel = null,
  isDownloadAvailable = true,
  isOneArtifact = false,
  isCandidateService = false,
  isProjectService = false,
  isRiskService = false,
  isStaffingService = false,
  budgetId,
}) => {
  const { AttachmentsListLayout, BaseFieldLayout } = useUiTheme();

  const { data } = useShowContext();
  const label = getLabel(propsLabel, source);
  const { getArtifactsDataByIds, getThumbnail, isArtifactsInfoReceiverLoading } = useArtifactService({
    isCandidateService,
    isProjectService,
    isRiskService,
    isStaffingService,
    budgetId,
  });
  const attachmentsIds = inputValue || (data && data.getValueBySource(source)) || [];
  const attachmentsRequestKey = JSON.stringify(attachmentsIds);

  const attachments = useAsyncValue(
    async () =>
      isArtifactsInfoReceiverLoading ? null : getArtifactsDataByIds(isOneArtifact ? [attachmentsIds] : attachmentsIds),
    [attachmentsRequestKey, isArtifactsInfoReceiverLoading, budgetId],
  );

  const { download } = useArtifactDownloadHelper({
    isCandidateService,
    isProjectService,
    isRiskService,
    isStaffingService,
    budgetId,
  });
  const { openPreview } = useArtifactPreviewHelper({
    isCandidateService,
    isProjectService,
    isRiskService,
    isStaffingService,
    budgetId,
  });

  return attachments ? (
    <AttachmentsListLayout
      attachments={attachments}
      label={label}
      downloadFile={download}
      getThumbnail={getThumbnail}
      openPreview={openPreview}
      isDownloadAvailable={isDownloadAvailable}
    />
  ) : (
    <BaseFieldLayout label={label} value={<InputLoader />} />
  );
};

export default AttachmentsListField;
